module.exports = __webpack_public_path__ + "assets/img/IMG024.f0ea055b.png";